import React from "react";
import {InputWrapper, SplitInputWrapperProps} from "../../functions";
import {ColorPicker} from "antd";
import {validations} from "../../../../config/validations/validations";
import {toLowerCaseWithUnderscore} from "../../../AgGridWrapper/utils/commonFunctions";

const ColorPickerInputBox: React.FC<any> = (props) => {
    const {
        formProps: {rules = [], ...formProps},
        inputProps,
    } = SplitInputWrapperProps(props);

    if (formProps?.required) {
        rules.filter((rule: any) => rule.required).length === 0 &&
            rules.push(validations.required.other());
    }

    return (
        <InputWrapper
            name={formProps?.label && toLowerCaseWithUnderscore(formProps?.label)}
            rules={rules}
            {...formProps}
            className="color-picker-input-design"
        >
            <ColorPicker popup onColorResult={(color: {rgb: any}) => color.rgb} {...inputProps} />
        </InputWrapper>
    );
};

export default ColorPickerInputBox;
